module.exports = __webpack_public_path__ + "static/media/Savings.6dab0b34.svg";